import { ReactElement } from "react"

import Snackbar from "components/common/snackbar/snackbar"
import { useSnackbar, OptionsObject } from "notistack"
import { SnackbarVariant } from "ts/types/Snackbar"

interface IArgsShowSnackbar {
  variant?: SnackbarVariant
  title: string
  description?: string
  options?: OptionsObject
  customBackground?: string
  customContent?: ReactElement
}

export const useCustomSnackbar = () => {
  const { enqueueSnackbar } = useSnackbar()

  const showSnackbar = ({
    variant = "success",
    title,
    description,
    options,
    customBackground,
    customContent,
  }: IArgsShowSnackbar) => {
    enqueueSnackbar(title, {
      ...options,
      content: (key, message) => (
        <Snackbar
          id={key}
          variant={variant}
          message={message}
          description={description}
          customBackground={customBackground}
          customContent={customContent}
        />
      ),
    })
  }

  return {
    showSnackbar,
  }
}
